import React from "react";

const Sport = () => {
  return (
    <div className="outerIframeContainer">
      <div className="iframe-container">
        <iframe
          src="https://tgtlive.com/"
          title="sport"
          width="100%"
          height="600"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default Sport;
